import { Component } from 'react'

/**
 * Wraps a chart so a render error (e.g. recharts axis NaN) is contained to
 * that one chart instead of crashing the whole dashboard to a white screen.
 */
export class ChartErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error('[ChartErrorBoundary] Chart failed to render:', error, info)
  }

  // Reset the error state when the inputs change (e.g. user picks a new period)
  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-[200px] flex items-center justify-center text-gray-400 text-sm bg-gray-50 rounded">
          This chart couldn’t be displayed for the selected range. Try a different period.
        </div>
      )
    }
    return this.props.children
  }
}
